<template>
  <div>
    <div class="tile is-parent">
        <article class="tile box" style="margin:0 25%">
          <h1 class="title">Edit Goal Information</h1>
          <form v-on:submit="updateGoal">
          <div class="block" style="margin:0 25%">
            <label class="label">Team</label>
              <p class="control">
                <span class="select">
                  <select>
                    <option>CDevils</option>
                    <option>SSteelers</option>
                  </select>
                </span>
              </p>
            
            
              <label class="label">Goal Scorer </label>
                <input class="input" type="number" placeholder="Player Number" v-model=Goal[0].scorer.player_number >

              <div class="control">
              <label class="label">First Assist</label>
              <p class="control">
                <input class="input " type="number" placeholder="First Assist"  v-model=Goal[0].first_assist.player_number>
              </p>
              <label class="label">Second Assists</label>
              <p class="control">
                <input class="input " type="number" placeholder="Second Assist" v-model=Goal[0].second_assist.player_number>
              </p>
              </div>
              <label class="label">Period</label>
              <p class="control">
                <input class="input " type="number" placeholder="Period"  v-model=Goal[0].period>
              </p>
              <label class="label">Situation</label>
              <p class="control">
                <input class="input " type="text" placeholder="Situation of Play i.e. EH5v5"  v-model=Goal[0].situation.secondary_situation>
              </p>
              <label class="label">Game Time</label>
              <p class="control">
                <datepicker   placeholder="Pick game time" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" v-model=Goal[0].game_time></datepicker>
              </p>
            <p class="control" style="margin-top:20px">
              <button name="submit" class="button is-primary is-medium">Submit</button>
              <router-link class="button is-link is-small" v-bind:to="'/editors/goal/'">Cancel</router-link>
            </p>
          </div>
          </form>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import Cleave from 'vue-cleave'
import 'cleave.js/dist/addons/cleave-phone.cn'
import Datepicker from 'vue-bulma-datepicker'

export default {
  components: {
    Cleave,
    Datepicker
  },

  data () {
    return {

      Goal: []
    }
  },

  methods: {
    fetchGoal (id) {
      console.log('Get query')
      this.$http.get('https://devilsapi.roblutken.com/api/goals/get/single/' + id, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Goal = response.data
        console.log(response.data)
      }, response => {
      })
    },
    updateGoal (e) {
      e.preventDefault()
      let updateGoal = {
        player_id: this.Goal[0].scorer.player_number,
        first_assist: this.Goal[0].first_assist.player_number,
        second_assist: this.Goal[0].second_assist.player_number,
        period: this.Goal[0].period,
        situation: this.Goal[0].situation.secondary_situation
      }

      console.log(updateGoal)
      console.log(this.$route.params.id)
      this.$http.put('https://devilsapi.roblutken.com/api/goals/update/' + this.$route.params.id,
      updateGoal, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        this.$router.push('/editors/goal/')
      }, response => {
      })
    },
    onRawValueChanged (newVal) {
      this.demo.rawValue = newVal
    }
  },
  watch: {
    'demo.value' (newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal)
    },
    'demo.rawValue' (newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal)
    }
  },
  created: function () {
    this.fetchGoal(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';

.button {
  margin: 5px 0 0;
}

.control .button {
  margin: inherit;
}

.control.has-addons {
  @include mobile() {
    input {
      width: 100%;
    }

    input.is-expanded {
      flex-shrink: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// goal-edit.vue?0a398236